import {
    MAKE_PAYMENT_START,
    MAKE_PAYMENT_SUCCESS,
    MAKE_PAYMENT_ERROR
} from '../../constants';
import { makePayment as mutation } from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { confirmPaymentAction } from './confirmPaymentAction';
import history from '../../history';

export function makePaymentAction({ stripe, bookingId, paymentType, paymentCurrency }) {


    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: MAKE_PAYMENT_START,
            });
            dispatch(setLoaderStart('paymentLoading'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    paymentType: Number(paymentType),
                    paymentCurrency
                },
            });

            const paymentResult = data?.makePayment?.result;

            if (data?.makePayment?.status === 400) {
                if (paymentResult?.requireAdditionalAction) {
                    const { error: actionError, paymentIntent } = await stripe.confirmCardPayment(paymentResult?.paymentIntentSecret);
                    if (actionError) {
                        showToaster({ messageId: 'errorMessage', requestContent: actionError.message, toasterType: 'error' });
                        dispatch(setLoaderComplete('paymentLoading'));
                        dispatch({ type: MAKE_PAYMENT_ERROR });
                    } else if (paymentIntent?.status === 'succeeded') {

                        const paymentIntentId = paymentIntent?.id;
                        dispatch(confirmPaymentAction({ bookingId, paymentIntentId }));
                    }
                } else if (paymentResult?.paymentType == 5 && paymentResult?.redirectURL) {
                    window.location = paymentResult?.redirectURL
                    return;
                }
                else {
                    showToaster({ messageId: 'errorMessage', requestContent: data?.makePayment?.errorMessage, toasterType: 'error' });
                    dispatch(setLoaderComplete('paymentLoading'));
                }
            } else {
                dispatch(setLoaderComplete('paymentLoading'));
                dispatch({ type: MAKE_PAYMENT_SUCCESS });
            }
        } catch (error) {
            dispatch({
                type: MAKE_PAYMENT_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}
